import { FEES } from '.';
import { SELECT_LENDER } from '../firebase/fetchLenders.ts';
import { SELECT_STATE } from '../firebase/fetchStates.ts';

export const DEFAULT_ACTIVE = {
  optionKey: 1,
  discount: '50%',
  fee: FEES.find((fee) => fee.id === 'no_fees'),
  privateSale: 'None',
  financePlan: 36, //  36 OR 24
  lender: SELECT_LENDER,
  preSale: false,
  newClient: false,
  state: SELECT_STATE,
  myMilanSecondary: null, // myMILAN as secondary lender for Split Finance
};
